const widgetPaths = {
  AGGREGATE_LIST: 'widget_data/:surveyId/aggregate_list/:widgetId/',
  STACKED_NUMBERS_LIST: 'widget_data/:surveyId/stacked_numbers_list/:widgetId/',
  AGGREGATE_RESPONSE: 'widget_data/:surveyId/aggregate_response/:widgetId/',
};
export const apiPaths = {
  ACCOUNT: {
    LOGIN_SSO: 'account/login/sso/',
    PASSWORD_RESET: 'account/password/reset/',
  },
  ADMIN: {
    BULK_EDIT: 'user-admin/bulk_edit/',
    CHECK_USER: 'user-admin/:id/check_copied_permissions/',
    USER: 'user-admin/',
    USER_ALL_SURVEYS: 'user-admin/all_surveys/',
    USER_ALL_SURVEYS_DETAIL: 'user-admin/:id/all_surveys_detail/',
    USER_EXPORT: 'user-admin/export_user_data/',
    USER_UPDATE_NEW_SURVEY: 'user-admin/:id/update_new_survey/',
  },
  BUSINESS_UNIT: 'business-unit/',
  CHATBOT: 'chatbot/',
  CUSTOMIZING: {
    CUSTOM_CONTENT: 'customizing/',
    SIMPLE_CONTENT_PAGE_BY_TYPE: 'content-page/simple_page_by_type/:page_type/',
    IMAGES: {
      CORPORATE_LOGO: 'customizing-media/image/corporate/',
      HEADER_LOGO: 'customizing-media/image/header/',
      TOOL_LOGO: 'customizing-media/image/tool/',
    },
  },
  DASHBOARD: {
    CODING_RESULTS: 're/dashboard/:id/statistics/coding_results/',
    COMMENTS: 're/dashboard/:id/comments/',
    COMMENTS_EXPORT: 'dashboard/comments_export/',
    EXPORT_RESPONSE_RATE: 'widget/:widgetId/get_response_rate_export/',
    GET_BY_MODULE_ID: 'dashboard/get_by_module_id/:moduleId/',
    GLOBAL: 'my-follow-up/global_dashboards/',
    STATISTICS: 're/dashboard/:id/statistics/',
    CROSS_SURVEY_BENCHMARK: 're/dashboard/:id/cross_survey_benchmark/',
    STATISTICS_BY_ORG_UNIT:
      're/dashboard/:dashboardId/org-unit-id/:orgUnitId/statistics/',
    TAGS: 're/dashboard/:id/statistics/tags/',
    WIDGET_RESULTS: 'dashboard-results/survey/:surveyId/',
    RESPONSE_RATES:
      'dashboard-results/local/response-rate-by-survey/:surveyId/',
  },
  EXPORT: 'export/',
  FOLLOW_UP: {
    OWNERS: 'follow-up/owners/',
    STATISTICS: {
      TOTAL_TICKETS:
        'widget_data/:surveyId/stacked_numbers_list/total_ticket_nps_group_by_status/:widgetId/',
    },
    TICKETS: {
      ADD_COMMENT: 'follow-up/ticket/:id/add-comment/',
      CHANGE_OWNER: 'follow-up/ticket/:id/change-owner/',
      CLOSE_TICKET: 'follow-up/ticket/:id/close/',
      DETAIL: 'follow-up/ticket/:id/',
      EXPORT: 'follow-up/tickets/export/',
      DOWNLOAD: 'follow-up/tickets/download/',
      FOLLOW_UP_CALL: 'follow-up/follow-up-calls/:id/',
      LIST: 'follow-up/tickets/',
      POTENTIAL_OWNERS: 'follow-up/ticket/:id/potential-owners/',
      REOPEN_TICKET: 'follow-up/ticket/:id/reopen/',
    },
  },
  FOLLOW_UP_INSPIRATIONS: {
    FILTER_GROUPS: 'follow-up-inspirations/filters/',
    INSPIRATIONS: 'follow-up-inspirations/inspirations/',
  },
  FOLLOW_UP_ACTIONS: {
    LIST: 'follow-up-action/',
    OWNERS: 'follow-up-action/owners/',
    CREATE: 'follow-up-action/',
    DETAIL: 'follow-up-action/:actionItemId/',
    DOWNLOAD_ALL: 'follow-up-action/download/all',
  },
  GET_CUSTOM_REPORTS: 'report/get_custom_reports/',
  GET_CUSTOM_REPORTS_BUNDLE: 'report/download_custom_bundle/',
  GET_CUSTOM_REPORTS_QUERY_SEARCH: 'report/get_custom_reports/?query=',
  GET_CUSTOM_REPORTS_SHARED: 'report/get_custom_reports/?shared_only=true',
  GET_CUSTOM_REPORTS_SHARED_QUERY_SEARCH:
    'report/get_custom_reports/?shared_only=true&query=',
  GET_DATALINE_RETURNS: 're/dataline/get_dataline_returns/',
  GET_REPORTS_BUNDLE: 'report/download_bundle/?module_id=',
  GET_TEMPLATES_QUERY_SEARCH: 'template/?query=',
  HIDE_EXPORT: 'export/:id/hide/',
  MAINTENANCE_MESSAGES: 'maintenance-messages/',
  MODULE_ROLE: 'module-role/',
  MY_FOLLOW_UP: {
    DOWNLOAD_ALL: 'my-follow-up/download/all/',
    LIST: 'my-follow-up/',
    OWNERS: 'my-follow-up/owners/',
    POTENTIAL_OWNERS: 'user/has_access_to_org_unit/',
    KPIS: 're/my-follow-up/kpis/',
  },
  ORDER_REPORT: 'report/:id/order_report/',
  ORG_UNIT: 'org-unit/',
  ORG_UNIT_ANCESTORS_BY_SURVEY:
    'org-unit/survey/:surveyId/:orgUnitId/ancestors/',
  ORG_UNIT_BY_SURVEY: 'org-unit/survey/:surveyId/',
  ORG_UNIT_CHILDREN: 'org-unit/:id/children/',
  ORG_UNIT_CHILDREN_BY_SURVEY: 'org-unit/survey/:surveyId/:orgUnitId/children/',
  ORG_UNIT_SEARCH: 'org-unit/get_org_unit_by_id_or_name/:searchTerm/',
  PLAN_ACTION: {
    ACTION_PLAN: 'action-plan/',
    COPY_ACTION_PLAN: 'action-plan/copy_action_plan/',
    DELETE_FILE: 'action-plan-attachment/',
    LIST_PLANS: 'action-plan/for-org-unit/',
    UPLOAD: 'action-plan-attachment/upload/',
  },
  REPORTS: {
    DETAIL: 'report/:id/',
    LIST: 'report/',
    ON_DEMAND: 're/on-demand-report/generate_on_demand_reports/',
    ON_DEMAND_EXPORT: 're/on-demand-report/export_on_demand_report/',
    SET_FAVORITE: 'report/:id/set_favourite/',
  },
  REPORT_CONFIG: {
    COMBINATION:
      'report-config-allocation/allocation_combination/survey/:surveyId/module/:moduleId/',
    AVAILABLE_LANGUAGES:
      'report-config-allocation/available_languages/survey/:surveyId/module/:moduleId/',
  },
  REPORT_ORDER_STATUS: 'report/get_status_by_report_ids/',
  ROLE: 'role/',
  SHAPING_BY_VARIABLE_ID: 'shaping/?variable_id=',
  SHARING: {
    GET_SHARED_WITH: 'user/get_shared_with/',
    MULTIPLE_REPORTS: 'report/share_multiple_reports/',
    REPORT: 'report/share_report/',
    TEMPLATE: 'template/share_template/',
  },
  SURVEY: {
    GET_GLOBAL: 'survey/get_global_survey/',
    LIST: 'survey/allocations/',
    SETTINGS: {
      DETAIL: 'survey/settings/:id/',
    },
    TOGGLE_FAVORITE: 'survey/:id/toggle_favorite/',
  },
  TEMPLATE: 'template/',
  TEMPLATE_SET_FAVORITE: 'template/:id/set_favourite/',
  USAGE: 'usage/',
  USER: {
    ACCEPT_TERMS: 'user/accept_terms_of_usage/',
    CHANGE_LANGUAGE: 'user/change_language/',
    GET_REPORT_USERS: 'user/get_sharable_users/',
    GET_SHARABLE_USERS_QUERY_SEARCH: 'user/get_sharable_users/?query=',
    ME: 'user/me/',
    SWITCH_SURVEY: 'user/switch_survey/',
    UPDATE_GUIDED_TOUR_COMPLETED_MODULES:
      'user/update_guided_tour_completed_modules/',
    FOLLOW_UP_PERMISSIONS: 'user/follow_up_permissions/',
  },
  VARIABLE: 'variable/',
  VARIABLE_BY_TYPE: 'variable/?variable_type=',
  VARIABLE_TYPE: 'variabletype/',
  VIRTUAL_ASSISTANT: {
    FEEDBACK: 're/virtual-assistant/feedback/',
    QUESTION: 're/virtual-assistant/question/',
    SESSIONS_CREATE: 're/virtual-assistant/sessions_create/',
    SESSIONS_DELETE: 're/virtual-assistant/sessions_delete/',
  },
  WIDGET_DATA: {
    AVERAGE_RESOLUTION_TIME: widgetPaths.STACKED_NUMBERS_LIST,
    COMPARISON_OF_UNITS: widgetPaths.STACKED_NUMBERS_LIST,
    DEEP_DIVE_QUESTIONS: widgetPaths.STACKED_NUMBERS_LIST,
    DETAILED_ORG_UNIT_RESPONSE_RATE: widgetPaths.STACKED_NUMBERS_LIST,
    DETRACTOR_TICKETS: widgetPaths.AGGREGATE_LIST,
    MYFOLLOWUP_STATE: widgetPaths.AGGREGATE_LIST,
    NPS_DISTRIBUTION: widgetPaths.AGGREGATE_LIST,
    NPS_SPEEDOMETER: widgetPaths.AGGREGATE_LIST,
    NPS_TREND_ANALYSIS: widgetPaths.AGGREGATE_LIST,
    TREND_ANALYSIS_RESPONSE_RATE: widgetPaths.AGGREGATE_LIST,
    OPEN_COMMENTS: {
      TOPICS: 're/widget_data/:surveyId/open_comments_categories/:widgetId/',
      COMMENTS: 're/widget_data/:surveyId/open_comments_with_topic/:widgetId/',
      EXPORT: 'widget_data/:surveyId/export_open_comments/:widgetId/',
    },
    ORG_UNIT_RESPONSE_RATE: widgetPaths.STACKED_NUMBERS_LIST,
    QUESTION: widgetPaths.AGGREGATE_RESPONSE,
    REASONS_FOR_LEAVING: widgetPaths.STACKED_NUMBERS_LIST,
    RESPONSE_FUNNEL: widgetPaths.AGGREGATE_LIST,
    RESPONSE_RATE: widgetPaths.AGGREGATE_RESPONSE,
    AGGREGATE_LIST: widgetPaths.AGGREGATE_LIST,
    TOTAL_TICKETS: widgetPaths.STACKED_NUMBERS_LIST,
  },
};
